import type { PageProps } from "./PageFullHeight.tsx";
import classNames from "classnames";
import { Footer } from "./Footer.tsx";

export function PageScrollable({
  title,
  children,
  showFooter = true,
}: PageProps) {
  return (
    <div
      className={classNames(
        "w-full min-h-full grid gap-4",
        title !== undefined
          ? "grid-rows-[auto_1fr_auto]"
          : "grid-rows-[1fr_auto]",
      )}
    >
      {title}
      {/*min-h-0 => schrumpfbar, flex + gap for inhalt*/}
      <div className={"h-full overflow-hidden grid grid-cols-1 justify-items-center"}>{children}</div>
      {showFooter && <Footer />}
    </div>
  );
}
